import Swiper, { Pagination } from 'swiper';
import { debounce } from 'lodash';
import Marquee from '@/modules/Marquee/Marquee.js';

class PartnersBroadcast {
  constructor(rootElement) {
    this.rootElement = rootElement;
    this.marquee = null;
    this.swiper = null;

    this.config = {
      marqueePoint: 768,
      sliderPoint: 767,
    };

    this.saveInitialDom();
    this.init();
    this.attachEvents();
  }

  saveInitialDom() {
    this.initialDom = this.rootElement.innerHTML;

    this.initialDom = this.initialDom.replace(/lozad/g, '');
    this.initialDom = this.initialDom.replace(/data-src/g, 'src');
  }

  init() {
    if (window.innerWidth >= this.config.marqueePoint) {
      this.initMarquee();
    }

    if (window.innerWidth <= this.config.sliderPoint) {
      this.initSlider();
    }
  }

  initSlider() {
    const slider = this.rootElement.querySelector('[data-entity="slider"]');
    const pagination = this.rootElement.querySelector('[data-entity="pagination"]');

    this.swiper = new Swiper(slider, {
      modules: [Pagination],

      enabled: true,
      slidesPerView: 1,
      spaceBetween: 0,

      pagination: {
        el: pagination,
        type: 'bullets',
        dynamicBullets: true,
        dynamicMainBullets: 4,
      },

      breakpoints: {
        [this.config.sliderPoint]: {
          enabled: false,
        },
      },
    });
  }

  initMarquee() {
    const element = this.rootElement.querySelector('[data-entity="marquee"]');
    this.marquee = new Marquee(element);
  }

  destroySwiper() {
    this.swiper.destroy();
    this.swiper = null;
  }

  destroyMarquee() {
    this.marquee.destroy();
    this.marquee = null;
  }

  destroyAllComponents() {
    if (this.marquee) {
      this.destroyMarquee();
    }

    if (this.swiper) {
      this.destroySwiper();
    }
  }

  attachEvents() {
    const debouncedHandler = debounce(this.windowResizeHandler.bind(this), 400);
    window.addEventListener('resize', debouncedHandler);
  }

  windowResizeHandler() {
    if (window.innerWidth >= this.config.marqueePoint) {
      this.destroyAllComponents();

      this.rootElement.innerHTML = this.initialDom;

      this.initMarquee();
    }

    if (window.innerWidth <= this.config.sliderPoint) {
      this.destroyAllComponents();

      this.rootElement.innerHTML = this.initialDom;

      this.initSlider();
    }
  }
}

export default PartnersBroadcast;
